import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState } from '../../../../store/app.selectors';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { FiltersTypes } from '../../interfaces/IWorkspace';
import { ChannelsService } from '../../services/channels.service';
import { getUnreadMessages } from '../../store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channels-list-filters',
  templateUrl: './channels-list-filters.component.html',
  styleUrls: ['./channels-list-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelsListFiltersComponent extends BaseComponent implements OnInit {
  private store = inject(Store<AppStateWithChat>);
  private channelsService = inject(ChannelsService);

  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });
  channelsFilter = computed(() =>
    this.chat().channelsFilter.filters.filter((filter) => this.channelsService.checkFiltersChannels(filter))
  );

  ngOnInit() {
    this.store.dispatch(getUnreadMessages());
  }

  get FiltersTypes(): typeof FiltersTypes {
    return FiltersTypes;
  }
}
